import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import persistState from 'redux-localstorage';
import reducer from '../reducers';
import rootSaga from '../sagas';

// https://hackernoon.com/redux-saga-tutorial-for-beginners-and-dog-lovers-aa69a17db645
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// include a logger
const middleware = [sagaMiddleware];
if (process.env.NODE_ENV !== 'production') {
  middleware.push(createLogger());
}

// dev tools middleware
// Use the Redux Devtools chrome extension to avoid the extra boilerplate.
//const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

export default (initialState = {}) => {
  const store = createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      persistState(['preferences', 'order'])
    )
  );

  // run the saga(s)
  sagaMiddleware.run(rootSaga);

  return store;
};
